import React from 'react';
import Grid from '@material-ui/core/Grid';
import EuBaner from '../../assets/img/EU.png';

declare const process: {
	env: {
		REACT_APP_COMMIT_HASH: string;
	};
};

interface IFooterProps {
	process: string;
}
interface IFooterState {
	mobileViewLocal: boolean;
}

const footer = {
	margin: '0',
	fontSize: '14px',
	padding: '15px',
};

const gridContainerStyle = {
	padding: '0 15px',
};

class Footer extends React.Component<IFooterProps, IFooterState> {
	state: IFooterState = {
		mobileViewLocal: false,
	};

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}
	onResize = () => {
		if (window.innerWidth < 800) {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: true }));
		} else {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: false }));
		}
	};

	render() {
		const { mobileViewLocal } = this.state;

		return (
			<footer id='footer' style={footer}>
				<Grid
					container
					item
					xs={12}
					justify='flex-end'
					style={gridContainerStyle}
				>
					<div>
						<a
							href='https://www.wisene.pl'
							className='wisene-link'
							data-testid='homePageFooterHref'
							target='_blank'
							rel='noopener noreferrer'
						>
							WISENE
						</a>
						<span
							className='footer-current-year'
							data-testid='homePageFooterCurrentYear'
							style={{ color: '#3c4858' }}
						>
							{mobileViewLocal ? '' : ` | 2010 - ${new Date().getFullYear()}`}
						</span>
						<span
							className='footer-hash-code'
							style={{ color: '#3c4858' }}
							data-testid='homePageFooterHashCode'
						>{` | ${process.env.REACT_APP_COMMIT_HASH}`}</span>
					</div>
				</Grid>
				<Grid
					style={{
						marginTop: '10px',
						borderRadius: '5px',
						padding: '20px',
						backgroundColor: 'rgba(0, 0, 0, 0.25)',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center'
					}}
				>
					<img src={EuBaner}
						style={{
							borderRadius: '5px',
							margin: 'auto',
							marginBottom: '10px',
							maxWidth: '75%',
						}}
						alt="Baner projekt współfinansowany ze środków Unii Europejskiej" />
					<p
						style={{
							color: 'white',
							margin: 'auto',
							maxWidth: '60%',
							textAlign: 'center'
						}}
					>Oprogramowanie powstało w ramach projektu nr RPMA 01.02.00-14-b526/18 pt. "Rozwój systemu automatycznego monitoringu konstrukcji dachów" współfinansowanego przez Unię Europejską ze środków Europejskiego Funduszu Rozwoju Regionalnego w ramach Regionalnego Programu Operacyjnego Województwa Mazowieckiego na lata 2014-2020.</p>
				</Grid>
			</footer>
		);
	}
}

export default Footer;
